export function configureLocalStorage(localStorageServiceProvider) {
    localStorageServiceProvider.setPrefix('Idha');
    localStorageServiceProvider.setStorageType('localStorage');
}